/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Author } from '../models/author';
import { AuthorResponsePage } from '../models/author-response-page';
import { getAuthor } from '../fn/authors/get-author';
import { GetAuthor$Params } from '../fn/authors/get-author';
import { listAuthors } from '../fn/authors/list-authors';
import { ListAuthors$Params } from '../fn/authors/list-authors';

@Injectable({ providedIn: 'root' })
export class AuthorsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listAuthors()` */
  static readonly ListAuthorsPath = '/v0/authors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAuthors()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAuthors$Response(params?: ListAuthors$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthorResponsePage>> {
    return listAuthors(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAuthors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAuthors(params?: ListAuthors$Params, context?: HttpContext): Observable<AuthorResponsePage> {
    return this.listAuthors$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthorResponsePage>): AuthorResponsePage => r.body)
    );
  }

  /** Path part for operation `getAuthor()` */
  static readonly GetAuthorPath = '/v0/authors/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuthor()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthor$Response(params: GetAuthor$Params, context?: HttpContext): Observable<StrictHttpResponse<Author>> {
    return getAuthor(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuthor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthor(params: GetAuthor$Params, context?: HttpContext): Observable<Author> {
    return this.getAuthor$Response(params, context).pipe(
      map((r: StrictHttpResponse<Author>): Author => r.body)
    );
  }

}
